/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Getsinfoanniversaryrecord3Inputs */

const de__field_getsinfoanniversaryrecord3 = /** @type {(inputs: _Field_Getsinfoanniversaryrecord3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juiläumskartenversand`)
};

/**

* @param {_Field_Getsinfoanniversaryrecord3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_getsinfoanniversaryrecord3 = /** @type {((inputs?: _Field_Getsinfoanniversaryrecord3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Getsinfoanniversaryrecord3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_getsinfoanniversaryrecord3(inputs)
});
export { _field_getsinfoanniversaryrecord3 as "_field_getsInfoAnniversaryRecord" }